import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "TEMPLATE", {
  DELETED: "Template deleted succesfully",
});
